const col = {
  name: { lg: 8, md: 8, xs: 8 },
  seq: { lg: 2, md: 4, xs: 4 },
  date: { lg: 3, md: 4, xs: 4 },
}

export default col
